var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdriveDndSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 65C50.6731 65 65 50.6731 65 33C65 15.3269 50.6731 1 33 1C15.3269 1 1 15.3269 1 33C1 50.6731 15.3269 65 33 65Z",
    fill: "white",
    stroke: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 41.4264L23.3494 43.5579C23.6058 44.0066 23.9744 44.3591 24.4071 44.6155L28.8141 36.9873H20C20 37.4841 20.1282 37.9809 20.3846 38.4296L22.1154 41.4264Z",
    fill: "#0066DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9905 28.0128L29.5834 20.3845C29.1507 20.6409 28.7821 20.9935 28.5257 21.4422L20.3846 35.5448C20.1329 35.9839 20.0003 36.4811 20 36.9872H28.8141L33.9905 28.0128Z",
    fill: "#00AC47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5742 44.6155C44.0069 44.3591 44.3755 44.0066 44.6319 43.5579L45.1447 42.6764L47.5967 38.4296C47.8531 37.9809 47.9813 37.4841 47.9813 36.9873H39.1665L41.0422 40.6732L43.5742 44.6155Z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9901 28.0129L38.3972 20.3846C37.9645 20.1282 37.4677 20 36.9548 20H31.0253C30.5125 20 30.0157 20.1442 29.583 20.3846L33.9901 28.0129Z",
    fill: "#00832D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1669 36.9873H28.8143L24.4072 44.6155C24.8399 44.872 25.3367 45.0002 25.8495 45.0002H42.1317C42.6445 45.0002 43.1413 44.8559 43.574 44.6155L39.1669 36.9873Z",
    fill: "#2684FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.526 28.4935L39.4555 21.4422C39.1991 20.9935 38.8305 20.6409 38.3978 20.3845L33.9907 28.0128L39.167 36.9872H47.9651C47.9651 36.4904 47.8369 35.9936 47.5805 35.5448L43.526 28.4935Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdriveDndSmall);
export default __webpack_public_path__ + "static/media/gdrive-dnd-small.a55e2bfe47860fe33d38e98ca4ac29a5.svg";
export { ForwardRef as ReactComponent };